import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'http-request',
  name: 'HTTP Request',
  category: 'web',
  description: 'Make HTTP requests to any API endpoint',
  icon: 'Globe',
  color: 'blue',
  version: '1.0.0',
  
  group: ['transform'],
  
  defaults: {
    name: 'HTTP Request',
    color: '#3b82f6'
  },
  
  subtitle: '={{ $parameter.method }} {{ $parameter.url }}',
  
  credentials: [
    {
      name: 'httpBasicAuth',
      required: false,
      displayName: 'Basic Auth',
      displayOptions: {
        show: {
          authentication: ['basicAuth']
        }
      }
    },
    {
      name: 'httpHeaderAuth',
      required: false,
      displayName: 'Header Auth',
      displayOptions: {
        show: {
          authentication: ['headerAuth']
        }
      }
    },
    {
      name: 'httpQueryAuth',
      required: false,
      displayName: 'Query Auth',
      displayOptions: {
        show: {
          authentication: ['queryAuth']
        }
      }
    },
    {
      name: 'httpOAuth2',
      required: false,
      displayName: 'OAuth2',
      displayOptions: {
        show: {
          authentication: ['oauth2']
        }
      }
    }
  ],
  
  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: true
    }
  ],
  
  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Output'
    }
  ],
  
  tags: ['http', 'api', 'rest', 'request', 'web'],
  
  comingSoon: false,
  
  // Tool-capable configuration for AI Agent
  toolCapable: {
    enabled: true,
    name: 'http_request',
    description: 'Make HTTP requests to external APIs to retrieve or send data. Supports GET, POST, PUT, DELETE methods with headers, query parameters, and request body.',
    allowManualDescription: true, // Allow users to customize the description for specific use cases
    parameters: {
      method: {
        toolParamName: 'method',
        description: 'HTTP method to use (GET, POST, PUT, DELETE, PATCH)',
        required: false,
        type: 'string'
      },
      url: {
        toolParamName: 'url',
        description: 'The complete URL to send the request to (including protocol)',
        required: true,
        type: 'string'
      },
      queryParameters: {
        toolParamName: 'query_params',
        description: 'Query parameters as a JSON object (e.g., {"key": "value"})',
        required: false,
        type: 'object'
      },
      headers: {
        toolParamName: 'headers',
        description: 'HTTP headers as a JSON object (e.g., {"Content-Type": "application/json"})',
        required: false,
        type: 'object'
      },
      body: {
        toolParamName: 'body',
        description: 'Request body as a JSON object or string',
        required: false,
        type: 'object'
      }
    },
    outputMapping: {
      statusCode: 'HTTP status code of the response',
      body: 'Response body (parsed JSON or raw text)',
      headers: 'Response headers as an object'
    }
  }
};

export default definition;
